import { useCallback, useState } from "react";

/**
 * Kirjauksen tunniste (T323, migraatio 131).
 *
 * Lomake luo tunnisteen kerran ja lähettää saman tunnisteen jokaisella yrityksellä, kunnes
 * kirjaus menee perille — vasta onnistunut vastaus vaihtaa uuden. Heikolla yhteydellä
 * ensimmäinen lähetys voi tallentua vaikka vastaus katoaa; uusi painallus samalla tunnisteella
 * palauttaa jo tallennetun rivin (`toisto: true`) eikä tee toista.
 *
 * Tunniste vaihdetaan vain onnistumisesta, ei sisällön muutoksesta: jos ensimmäinen meni
 * perille ja sisältöä muutettiin ennen uutta painallusta, palvelin palauttaa tallennetun eikä
 * ylikirjoita — ja lomake sanoo sen ääneen.
 */
export function uusiKirjaustunniste(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  // randomUUID vaatii suojatun yhteyden; tunnelissa (http://localhost) sitä ei aina ole.
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** [tunniste, vaihda] — kutsu `vaihda()` vasta onnistuneen kirjauksen jälkeen. */
export function useKirjaustunniste(): [string, () => void] {
  const [tunniste, setTunniste] = useState(uusiKirjaustunniste);
  const vaihda = useCallback(() => setTunniste(uusiKirjaustunniste()), []);
  return [tunniste, vaihda];
}

export const TOISTON_ILMOITUS =
  "Kirjaus oli jo tallentunut edellisellä lähetyksellä — toista riviä ei tehty.";
